import { useForm } from "react-hook-form";
import { Dialog } from "components/Dialog";
import { Button } from "components/Button";
import { useTranslation } from "react-i18next";
import {
  WaterMeterAuthType,
  WaterMeterCommunicationType,
  WaterMeterLocationType,
  WaterMeterModelType,
  WaterMeterType,
} from "types/dto";
import { useState } from "react";
import { TypeStep } from "./TypeStep";
import { InfoStep } from "./InfoStep";

type TStep = "TYPE" | "INFO";
type TProps = {
  isOpen?: boolean;
  onClose: () => void;
  onSubmit: (value: TAddFormTypes) => void;
  isLoading: boolean;
};

export type TAddFormTypes = {
  serialNo: string;
  productionYear: number;
  waterMeterType: WaterMeterType;
  locationType: WaterMeterLocationType;
  modelType: WaterMeterModelType;
  provinceId?: string;
  cityId?: string;
  jurisdictionId?: string;
  config: {
    communicationType: WaterMeterCommunicationType;
    authType: WaterMeterAuthType;
    encryptionkey: string;
    // Only for OTTA
    devEUI: string;
    appEUI: string;
    loraAppKey: string;
    // Only for ABP
    loraAppSKey: string;
    loraDeviceAddress: string;
    loraNetworkKey: string;
  };
};

export function AddMeterModal(props: TProps) {
  const { isOpen = false, onClose, onSubmit, isLoading } = props;

  const [step, setSteps] = useState<TStep>("TYPE");

  const { t } = useTranslation();

  const {
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
    trigger,
  } = useForm<TAddFormTypes>({
    defaultValues: undefined,
  });

  const onBackClick = () => {
    setSteps("TYPE");
  };
  const onContinueClick = () => {
    if (step === "TYPE") {
      setSteps("INFO");
    }
    if (step === "INFO") {
      handleSubmit(onSubmit)();
    }
  };

  return (
    <Dialog
      maxWidth={false}
      dialogTitle={t("addMeter")}
      open={isOpen}
      onClose={onClose}
      canClose={!isLoading}
    >
      <div className="p-4 w-[640px]">
        {step === "TYPE" && <TypeStep control={control} />}
        {step === "INFO" && (
          <InfoStep control={control} watch={watch} setValue={setValue} />
        )}

        <div className="col-span-12 flex items-center justify-end mt-5 gap-x-2">
          {step === "INFO" && (
            <Button
              className="w-20"
              disabled={isLoading}
              type="button"
              variant="outlined"
              onClick={onBackClick}
            >
              {t("back")}
            </Button>
          )}
          <Button
            className="w-20"
            loading={isLoading}
            disabled={step === "TYPE" && !watch("modelType")}
            type="submit"
            variant={step === "TYPE" ? "outlined" : "contained"}
            onClick={onContinueClick}
          >
            {step === "TYPE" ? t("continue") : t("add")}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
